const baseConfig = {
    routeUrl: '/penguin/public/index.php',
    // routeUrl: '/mind360Test/penguin/public/index.php',
    // httpUrl 是代码中所用的请求公共地址
    // httpUrl: 'http://localhost:3000/penguinUrl/penguin/public/index.php',
    httpUrl: '/penguin/public/index.php',
    // httpUrl: '/mind360Test/penguin/public/index.php',
}

export default baseConfig;